import { computed, ref, Ref } from 'vue';
import { ComplexModal } from '@studyportals/modal';

export default class ServiceBlockedModalCode {
	public modalContent: Ref<HTMLElement | null> = ref(null);
	private modal: Ref<ComplexModal | undefined> = ref(undefined);

	constructor(private readonly reason: string) {}

	public blockReason = computed((): string => {
		return this.reason;
	});

	public mounted(): void {
		this.prepareModal();
	}

	private prepareModal(): void {
		if (!this.modalContent.value) {
			return;
		}

		this.modal.value = new ComplexModal(
			this.modalContent.value,
			{
				cssClassName: 'ServiceBlockedModalWrapper',
				destroyOnClose: false
			}
		);

		window.ModalManager.open(this.modal.value);
	}
}
